import styled from "styled-components";

interface RoundedPillProps {
    background: string
}

export const RoundedPill = styled.div`
  border-radius: 32px;
  padding: 5px 12px;
  width: fit-content;
  text-transform: uppercase;
  font-size: 11px;
  font-weight: 700;
  margin: auto;
  color: ${({theme}) => theme.white};
  background: ${({background}: RoundedPillProps) => background};
`
